<template>
  <div class="occasion has-text-centered">
    <p>{{ isFuture ? $t('occasions.youLlBe') : $t('occasions.youWere') }}</p>

    <p class="occasion__heading">
      <span v-resize-text="{ maxFontSize: 28, minFontSize: 18 }">
        {{ roundedNumber | numberWithCommas }}
      </span>

      {{ $t(`occasions.periodsLabels.${dateKey}`) }} {{ $t('occasions.old') }}
    </p>

    <p>
      {{ $t('occasions.on') }} <span class="has-text-weight-bold">{{ toCalendarDate(addedDate) }}</span>
    </p>

    <p
      v-if="isFuture"
      class="is-size-7"
    >
      ({{ $t('occasions.inXDays', { value: addedDate.diff(currentDate, 'days') }) }})
    </p>

    <p
      v-else
      class="is-size-7"
    >
      ({{ $t('occasions.daysAgo', { value: currentDate.diff(addedDate, 'days') }) }})
    </p>

    <i
      v-if="icon"
      :class="`occasion__icon occasion__icon--${icon}`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Occasion',
  props: {
    dateKey: { type: String, required: true },
    icon: { type: String, default: '' },
    isFuture: { type: Boolean, default: false },
    keepFirstDigits: { type: Number, default: 1 },
  },
  computed: {
    ...mapState([
      'birthDate',
      'currentDate',
    ]),
    addedDate() {
      return moment(this.birthDate).add(this.roundedNumber, this.dateKey)
    },
    period() {
      return Array.from(String(this.currentDate.diff(this.birthDate, this.dateKey)), Number)
    },
    roundedNumber() {
      // keepFirstDigits prop defines how many numbers from the start
      // we should use as a base, default is just first one. in case of 2:
      // 910601216 => 910000000 in case it's for past
      // 910601216 => 920000000 in case it's for future
      const firstPart = this.period.slice(0, this.keepFirstDigits)
      const newNumberArr = Array(this.period.length).fill(0)

      if (this.isFuture) {
        const firstPartNumber = Number(firstPart.join(''))

        newNumberArr.splice(0, this.keepFirstDigits, firstPartNumber + 1)
      } else {
        newNumberArr.splice(0, this.keepFirstDigits, ...firstPart)
      }

      return newNumberArr.join('')
    },
  },
  methods: {
    toCalendarDate(date) {
      return date.calendar(null, { sameElse: 'DD.MM.YYYY' })
    },
  },
}
</script>
